import { Exclude, Expose } from 'class-transformer';

import { BaseModel } from '@core/data-access';
import { Default } from '@core/util';

@Exclude()
export class PaginationModel extends BaseModel {
  @Expose({ name: 'itemsPerPage' })
  @Default(12)
  limit!: number;

  @Expose({ name: 'currentPage' })
  @Default(1)
  page!: number;

  @Expose({ name: 'totalPages' })
  pageCount!: number;

  @Expose({ name: 'totalItems' })
  total!: number;

  @Expose()
  @Default([12, 24, 36, 48])
  pageSizeOptions!: number[];
}
